export default __webpack_public_path__ + "static/media/parkingrampe7.7c30eac9.png";